import type { SiteConfig } from '@/temporary-site-config';

export const isFeatureEnabled = (
	feature: string,
	config: SiteConfig,
): boolean => {
	return Boolean(config.features2.flags[feature]?.enabled);
};
